import type { SVGProps } from "react";
export interface Puzzle02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Puzzle02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Puzzle02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.654 1.763a3.97 3.97 0 0 1 5.31.273l.272.302a3.967 3.967 0 0 1-.272 5.308l-.013.012a4.5 4.5 0 0 1-.85.631l.792.793a4.126 4.126 0 0 1 0 5.834l-.001-.001-1.956 1.96a1.125 1.125 0 0 1-1.854-.413c-.169-.468-.38-1.17-.815-1.622a1.717 1.717 0 0 0-2.29-.111l-.13.118a1.717 1.717 0 0 0-.007 2.42c.452.436 1.154.646 1.622.815a1.126 1.126 0 0 1 .413 1.854l-1.96 1.956.001.001a4.126 4.126 0 0 1-5.52.283l-.314-.283-.793-.792c-.173.293-.38.59-.631.85l-.012.012a3.967 3.967 0 0 1-5.308.273l-.302-.273a3.97 3.97 0 0 1 0-5.61l.013-.012.17-.155c.215-.184.447-.341.678-.477l-.79-.791a4.126 4.126 0 0 1 0-5.835l1.956-1.958.107-.096a1.125 1.125 0 0 1 1.748.509c.168.467.378 1.168.813 1.62a1.717 1.717 0 0 0 2.421-.006l.117-.13a1.717 1.717 0 0 0-.111-2.291c-.452-.435-1.153-.645-1.62-.813a1.126 1.126 0 0 1-.413-1.855l1.958-1.957.314-.283a4.125 4.125 0 0 1 5.52.283l.792.791c.173-.293.38-.588.633-.848l.011-.013.3-.273Zm3.719 1.864a1.72 1.72 0 0 0-2.422-.008c-.435.452-.644 1.156-.813 1.623a1.126 1.126 0 0 1-1.854.413l-1.959-1.958a1.875 1.875 0 0 0-2.509-.129l-.142.129-.792.79c.23.137.463.293.678.477l.171.155.012.012.272.302a3.97 3.97 0 0 1 0 5.01l-.272.3a3.97 3.97 0 0 1-5.612 0l-.012-.012a4.5 4.5 0 0 1-.63-.85l-.792.793a1.875 1.875 0 0 0 0 2.651l1.959 1.96a1.125 1.125 0 0 1-.414 1.853c-.467.169-1.17.378-1.623.813a1.72 1.72 0 0 0 .008 2.422l.13.118c.674.55 1.67.51 2.298-.12.43-.452.639-1.15.806-1.614l.057-.13a1.125 1.125 0 0 1 1.796-.283l1.959 1.958.143.13c.737.6 1.823.557 2.51-.13l.79-.792a4.5 4.5 0 0 1-.848-.63l-.011-.012.795-.797-.795.796a3.967 3.967 0 0 1 0-5.61l.301-.273a3.97 3.97 0 0 1 5.009 0l.3.273.013.011.155.17c.184.214.34.448.475.678l.791-.79h.002a1.876 1.876 0 0 0 .128-2.51l-.129-.144-1.958-1.958a1.125 1.125 0 0 1 .413-1.853c.465-.168 1.164-.377 1.616-.809a1.715 1.715 0 0 0 .118-2.295z"
      />
    </svg>
  );
}
